interface ActivityMetaRowProps {
    parts: string[];
}

export const ActivityMetaRow = (props: ActivityMetaRowProps) => (
    <div className="flex flex-wrap items-center gap-s text-l text-p6-grey-dark">
        {props.parts.map((part, index) => (
            <span
                key={part}
                className="flex items-center gap-s"
            >
                <span>{part}</span>
                {index < props.parts.length - 1 && <span aria-hidden="true">•</span>}
            </span>
        ))}
    </div>
);
